import CrudBase from '../../CrudBase';
import axios from '../../../axios-common';

// import response from '../../../demo/data/account.json'

class UsersApi extends CrudBase {
  listExtUsers = async () => axios.get(`${this.endpoint}/ext`);
  getCurrentUser = async () => axios.get('api/v1/representative/current-user');
  renewAuthorities = async () => axios.get('/api/account/users/renew-authorities');
  login = async (data) => axios.post('api/login', data);
  // getMenus = async () => axios.get('/api/account/users/menus');

  // listExtUsers = async () => axios.get(`${this.endpoint}/ext`);
  // getCurrentUser = () => { return { data: response.getCurrentUser } };
  // renewAuthorities = async () => { return { data: response.login } };
  // getMenus = (isLogged) => { return isLogged ? { data: response.menus } : { data: [] }; };
  // login = (data) => {
  //   if(data.username === "REP" && data.password === "pass") {
  //     return { data: response.login }
  //   } else {
  //     return false;
  //   }
  // }

  defaultMethods = {
    ...this.defaultMethods,
    listByEmpresa: this.listByEmpresa,
    listExtUsers: this.listExtUsers,
    getCurrentUser: this.getCurrentUser,
    renewAuthorities: this.renewAuthorities,
    // getMenus: this.getMenus,
    login: this.login,
  }
}

const users = new UsersApi('api/account/users');

export default {
  ...users.defaultMethods,
};
